import { useMemo } from 'react';
import { PERCENTAGE_PRECISION, ZERO } from '@drift-labs/sdk';
import { useVaultOnChainData } from 'src/hooks/query/vaults/base/useVaultOnChainData';
import { useSubscribedVaultContext } from 'src/providers/vaults/SubscribedVaultProvider';
import {
	FEES_PLACEHOLDER,
	MANAGEMENT_FEE_PLACEHOLDER,
	PERIOD_PLACEHOLDER,
	Placeholders,
} from 'src/constants/vaults/misc';
import { redeemPeriodToString } from 'src/utils/vault/withdraw';

export type PlaceholdersReplacements = {
	[key in Placeholders]: string;
};

export const usePlaceholdersReplacements = () => {
	const { vaultPubkey } = useSubscribedVaultContext();
	const { data: onChainData } = useVaultOnChainData();
	const vaultAccountData = onChainData?.[vaultPubkey]?.vaultAccountData;

	const profitShareFee =
		(vaultAccountData?.profitShare ?? 0) / PERCENTAGE_PRECISION.toNumber();
	const profitShareFeePct = profitShareFee * 100;
	const withdrawalWaitingPeriod = redeemPeriodToString(
		vaultAccountData?.redeemPeriod.toNumber()
	);
	const managementFee = `${(vaultAccountData?.managementFee ?? ZERO)
		.muln(100)
		.div(PERCENTAGE_PRECISION)
		.toNumber()}%`;

	const placeholdersReplacements: PlaceholdersReplacements = useMemo(() => {
		return {
			[FEES_PLACEHOLDER]: `${profitShareFeePct}%`,
			[PERIOD_PLACEHOLDER]: withdrawalWaitingPeriod,
			[MANAGEMENT_FEE_PLACEHOLDER]: managementFee,
		};
	}, [profitShareFeePct, withdrawalWaitingPeriod, managementFee]);

	return placeholdersReplacements;
};
